<priva-form>
    <priva-form-group [hasLabel]="false" [hasHelp]="false" [isInline]="true">
        <div class="amount-result-label">{{ 'GENERAL.TITLE.AMOUNT' | translate }}</div>
        <div class="amount-result-input-wrapper" #amountResultInput>
            <priva-form-input-group
                [appendTemplate]="amountInputTextTmp"
                [inputTemplate]="amountInputTmp"
                data-test="form-input-group-amount-result"
            />
        </div>
        <ng-template #amountInputTmp>
            <ng-container [formGroup]="formGroup">
                <input
                    #amountInput
                    priva-input
                    placeholder=""
                    formControlName="amountResult"
                    type="text"
                    inputmode="decimal"
                    data-test="input-amount-result"
                    (keydown.enter)="blurInput()"
                />
            </ng-container>
        </ng-template>
        <ng-template #amountInputTextTmp>
            <p class="amount-result-input-text__unit-label">{{ (unit$ | async) ?? '' }}</p>
        </ng-template>
    </priva-form-group>
</priva-form>
@if (!formGroup.valid) {
    <priva-popover
        [relativeTo]="amountResultInput"
        placement="top"
        theme="onwhite"
        status="Danger"
        [autoClose]="false"
        density="lg"
        data-test="amount-result-error"
    >
        {{ formGroup.errors?.['format'] | translate: { formatErrorValue: formGroup.errors?.['errorValue'] } }}
    </priva-popover>
}
